/**
 * tour-step.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { ReactSVG } from 'react-svg'
import learn from 'assets/images/learn.svg';
import { shouldRenderMobileLayout } from 'utils/app-context';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftPanel: {
    width: theme.spacing(15),
    '& .learnSvg svg': {
      width: '100%',
      height: 'auto',
      '& .custom-fill': {
        fill: theme.palette.primary.main,
      }
    }
  },
  name: {
    fontSize: theme.typography.sizes[0],
    textTransform: 'uppercase',
    color: theme.palette.grey.colors[6],
    marginTop: theme.spacing(0.5),
  },
  text: {
    textAlign: 'left',
    fontSize: theme.typography.body2.fontSize,
    width: theme.spacing(45),
  },
}));


export default function TourStep(props) {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      {!shouldRenderMobileLayout() &&
      <div className={classes.leftPanel}>
        <ReactSVG
          src={learn}
          className="learnSvg"
        />
        <div className={classes.name}>{props.name}</div>
      </div>}
      <div className={classes.text}>
        {props.children}
      </div>
    </div>

  );
}